import URI from "urijs";

export default {
    methods: {
        /**
         * @param data
         * @param filename
         * @param type
         */
        downloadFile(data, filename, type) {
            let file = new Blob([data], {
                type: type,
            });
            if (window.navigator.msSaveOrOpenBlob)
                // IE10+
                window.navigator.msSaveOrOpenBlob(file, filename);
            else {
                // Others
                let a = document.createElement('a'),
                    url = URL.createObjectURL(file);
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                setTimeout(async () => {
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                }, 1);
            }
        },
        getFile(url) {
            return this.$api.request({
                url: url,
                method: 'GET',
                responseType: 'blob'
            }).then(response => {
                /**
                 * @link https://github.com/axios/axios#response-schema
                 *   // `headers` the HTTP headers that the server responded with
                 *   // All header names are lowercase and can be accessed using the bracket notation.
                 *   // Example: `response.headers['content-type']`
                 */
                this.downloadFile(
                    response.data,
                    decodeURI(response.headers['x-suggested-filename'] || (new URI(url)).filename()),
                    response?.headers['content-type'] || 'application/octet-stream'
                );
            }).catch(this.notifyError);
        },
    },
}
